/**
 *  HTTP Service
 * 
 * @copyright NIIT Technologies Ltd. 2017-18
 */

import { Component, Inject, Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable, Subscription } from 'rxjs/Rx';
//
import { BaseService } from './base.service';
import { Event, NotificationType, HTTPMethod, HTTPContentType, BaseResponse } from '../common/base.data';
//

/**
 *  HTTP Service
 */

export class HTTPService extends BaseService {

    /**
     * Initialize
     */
    constructor(private http: Http) {
        super();
    }

    /**
     * Gets Data (Async)
     * 
     * @param url URL
     * @param contentType Content Type
     * @param data Data
     */
    public getHTTPData(url: string, contentType: string, data: string): Observable<BaseResponse> {
        let headers = new Headers({
            'Content-Type': contentType
        });
        let options = new RequestOptions({ headers: headers, withCredentials: true });
        // Send HTTP  Get Request
        return this.http.get(url + data, options).map(this.handleResponse)
            .catch(this.handleError);
    }

    /**
     * Post Data (Async)
     * 
     * @param url URL
     * @param contentType Content Type
     * @param data Data
     */
    public postHTTPData(url: string, contentType: string, data: any): Observable<BaseResponse> {
        let headers = new Headers({
            'Content-Type': contentType
        });
        let options = new RequestOptions({ headers: headers, withCredentials: true });
        // Send HTTP  Post Request
        return this.http.post(url, data, options).map(this.handleResponse)
            .catch(this.handleError);
    }

    /**
     * Handle HTTP Successful Call
     */
    private handleResponse(response: Response) {
        let contentType = response.headers.get("content-type");
        let body = null;
        // If JSON
        if (contentType && contentType.indexOf(HTTPContentType.JSON) != -1) {
            body = response.json();
        } else {
            body = response.text();
        }
        //
        return body;
    }

    /**
     * Handle HTTP Call Error
     */
    private handleError(error: Response | any) {
        let errMsg: string;
        //
        if (error instanceof Response) {
            // Check for Server Availability
            if (error.status == 0) {
                errMsg = `Unable to contact Server. Please verify whether Server is up or down.`;
            } else {
                errMsg = `Unexpected error occured on Server. HTTP Status ${error.status} - ${error.statusText} ${error.url}`;
            }
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        //
        return Observable.throw(errMsg);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
